import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';

const { TextArea } = Input;

const SaveQueryModal = ({ 
  visible, 
  onClose, 
  onSave, 
  loading = false,
  initialValues = {}
}) => {
  const [form] = Form.useForm();

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      await onSave(values);
      form.resetFields();
      onClose();
    } catch (error) {
      console.error('Form validation failed:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Save Query"
      open={visible}
      onCancel={handleCancel}
      styles={{
        content: {
          borderRadius: 0,
          padding: 0
        },
        header: {
          borderRadius: 0,
          borderBottom: '1px solid #E5E7EB',
          padding: '16px 24px',
          margin: 0
        },
        body: {
          padding: '20px 24px',
          borderRadius: 0
        },
        footer: {
          borderRadius: 0,
          borderTop: '1px solid #E5E7EB',
          padding: '12px 24px'
        }
      }}
      footer={[
        <Button 
          key="cancel" 
          onClick={handleCancel}
          className="transition-all duration-200 hover:opacity-90"
          style={{ 
            color: '#0f172a',
            borderColor: '#E5E7EB',
            borderWidth: '1px',
            borderStyle: 'solid',
            backgroundColor: '#ffffff',
            fontFamily: 'Raleway, sans-serif',
            fontWeight: 500,
            fontSize: '13px',
            borderRadius: '0px',
            padding: '6px 12px',
            height: '28px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}
        >
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          loading={loading}
          onClick={handleSave}
          className="transition-all duration-200 hover:opacity-90"
          style={{ 
            backgroundColor: '#1d0c46', 
            borderColor: '#1d0c46',
            border: 'none',
            color: '#ffffff',
            fontFamily: 'Raleway, sans-serif',
            fontWeight: 500,
            fontSize: '13px',
            borderRadius: '0px',
            padding: '6px 12px',
            height: '28px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}
        >
          Save Query
        </Button>
      ]}
      width={500}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        requiredMark={false}
      >
        <Form.Item
          name="queryName"
          label="Query Name"
          rules={[
            { required: true, message: 'Please enter a query name' },
            { max: 200, message: 'Query name must be less than 200 characters' }
          ]}
        >
          <Input 
            placeholder="Enter a descriptive name for your query"
            maxLength={200}
          />
        </Form.Item>

        <Form.Item
          name="description"
          label="Description (Optional)"
          rules={[
            { max: 1000, message: 'Description must be less than 1000 characters' }
          ]}
        >
          <TextArea
            placeholder="Describe what this query does..."
            rows={3}
            maxLength={1000}
            showCount
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SaveQueryModal;
